import React from "react";
import ChooseNFTCard from "../ChooseNFTCard/ChooseNFTCard";
import thum from "./assets/thum.png";
const ChooseNFTPopup = ({ setSelectedNft, setOpen }) => {
  return (
    <>
      <div className="absolute z-20 top-[50px] right-0 w-[300px] md:w-[700px] bg-custom-gradient rounded-[10px] pb-[31px]">
        <div className="flex justify-center items-center mb-[17px] ">
          <div className="text-center w-[140px] md:w-[250px] h-[35px] md:h-[57px] rounded-b-[20px] text-[15px] md:text-[30px] font-extrabold leading-[36px] bg-main-black">
            Choose NFT
          </div>
        </div>
        <div>
          <h2 className="text-main-black text-[15px] text-center font-semibold leading-[18px] mb-[30px]">
            R34P DAO Access is based on NFT Tiers 1 or 2. Select your desired
            Access Level
          </h2>
          <div className="flex w-full pl-[20px] flex-wrap gap-[22px] md:pl-[73px] px-[2px] md:pr-[40px] h-[347px] overflow-y-scroll overflow-x-hidden chooseNft mr-[42px]">
            <ChooseNFTCard
              setSelectedNft={setSelectedNft}
              thum={thum}
            ></ChooseNFTCard>
            <ChooseNFTCard
              setSelectedNft={setSelectedNft}
              thum={thum}
            ></ChooseNFTCard>
            <ChooseNFTCard
              setSelectedNft={setSelectedNft}
              thum={thum}
            ></ChooseNFTCard>
            <ChooseNFTCard
              setSelectedNft={setSelectedNft}
              thum={thum}
            ></ChooseNFTCard>
            <ChooseNFTCard
              setSelectedNft={setSelectedNft}
              thum={thum}
            ></ChooseNFTCard>
          </div>
        </div>
      </div>
      <div
        className="fixed top-0 right-0 bottom-0 left-0 z-10 "
        onClick={() => setOpen(false)}
      ></div>
    </>
  );
};

export default ChooseNFTPopup;
